// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"12":"60ed4aa4","35":"7b4cfda4","83":"9018b61e","151":"519e5fff","428":"38cfc7ea","631":"096aaa24","701":"c0fc5943"}[chunkId] + ".css";
};